import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { message } from "antd";
import ReactModal from "react-modal";
import { useLocation } from "react-router-dom";
import {
  user_session_data_enroll_api,
  user_payment_details_api,
  user_session_data_configfree_api,
  user_session_data_access_api,
  user_session_data_custsetup_ep_api,
  custfeature_api,
  cancel_subscription_api,
  subscription_api,
  after_successful_login_api,
  free_add_custadmin_api,
  validate_special_price_code_api,
} from "../../../services/NewUI_API";
import {
  CheckCircleOutlined,
  FileTextOutlined,
  BulbOutlined,
  DashboardOutlined,
  BarChartOutlined,
  EnvironmentOutlined,
  EditOutlined,
  RobotOutlined,
  SafetyCertificateOutlined
} from "@ant-design/icons";


const EnrollUI = () => {
  const [theme, setTheme] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [confirmedSpeccode, setConfirmedSpeccode] = useState("");
const [confirmedSpeccodeData, setConfirmedSpeccodeData] = useState(null);
const renewFlag = localStorage.getItem("renewFlag") === "yes";
    useEffect(() => {
setTheme(localStorage.getItem('brandColor'));
    setCustomer(localStorage.getItem('customerid'));
  }, []); 
   useEffect(() => {
      if(localStorage.getItem("brandColor") == null || localStorage.getItem("brandColor") == '' ){
        localStorage.setItem("brandColor","#ff8c24");  console.log("vasanth==>", );
    
      }
    }, []);
  const StyledButton1 = styled.button`
  background: ${theme} !important;
  width: 210px;
  border-radius: 30px;
  height: 50px;
  text-align: center;
  font-size: 20px !important;
  color: white;
  font-weight: 900;
  border-color: none;
  border: none;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(255, 107, 0, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

const StyledButton2 = styled.button`
  background: #ff8c24 !important;
  width: 275px;
  border-radius: 30px;
  height: 50px;
  text-align: center;
  font-size: 20px !important;
  color: white;
  font-weight: 900;
  border-color: none;
  border: none;
`;

const StyledApplyButton = styled.button`
  background: ${theme} !important;
  width: 80px;
  border-radius: 10px;
  height: 38px;
  text-align: center;
  font-size: 18px !important;
  color: white;
  font-weight: 700;
  border: none;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(255, 107, 0, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;


const ModalStyle_Del = {
  content: {
    width: "500px",
    height: "200px !important",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    justifyContent: "center",
  },
};

const StyledButton = styled.button`
  background: ${theme} !important;
  width: 100%;
  border-radius: 30px;
  height: 45px;
  text-align: center;
  color: white;
  font-size: 16px !important;
  font-weight: 500;
  border-color: none;
  border: none;
  margin-top: 25px;
  padding: 5px 10px;
`;





  const location = useLocation();
  const plans = [
    {
      id: 1,
      name: "Limited Trial",
      location: "1",
      users: "1",
      price: "0",
      buttonText: "Go to Dashboard",
      features: [
        { name: "Access to One Topic", icon: <CheckCircleOutlined /> },
        { name: "Basic Suggestion Report", icon: <FileTextOutlined /> }
      ]
    },
    {
      id: 2,
      name: "Small Business",
      location: "1",
      users: "up to 4",
      price: "660",
      price_id: "price_1SPMBkCxPlnlMJHkPvlSHUlP",
      buttonText: "Subscribe",
      features: [
        { name: "General and Sector Topics", icon: <CheckCircleOutlined /> },
        { name: "Full Suggestion Report", icon: <FileTextOutlined /> },
        { name: "Guidance for Gaps", icon: <BulbOutlined /> },
        { name: "Progress Dashboard", icon: <SafetyCertificateOutlined /> },
        { name: "Performance Reports", icon: <BarChartOutlined /> },
        // { name: "Reporting by Location", icon: <EnvironmentOutlined /> },
        { name: "Create Custom Topics", icon: <EditOutlined /> },
        { name: "AI Assistant", icon: <RobotOutlined /> }
      ]
    },
    {
      id: 3,
      name: "Multi-Site",
      location: "up to 5",
      users: "up to 24",
      price: "1800",
      price_id: "price_1SPMKYCxPlnlMJHkJLZVPl2t",
      buttonText: "Subscribe",
      features: [
        { name: "General and Sector Topics", icon: <CheckCircleOutlined /> },
        { name: "Full Suggestion Report", icon: <FileTextOutlined /> },
        { name: "Guidance for Gaps", icon: <BulbOutlined /> },
        { name: "Progress Dashboard", icon: <SafetyCertificateOutlined /> },
        { name: "Performance Reports", icon: <BarChartOutlined /> },
        // { name: "Reporting by Location", icon: <EnvironmentOutlined /> },
        { name: "Create Custom Topics", icon: <EditOutlined /> },
        { name: "AI Assistant", icon: <RobotOutlined /> }
      ]
    },
    {
      id: 5,
      name: "Enterprise",
      location: "6 or more",
      users: "25 or more",
      price: "0",
      buttonText: "Contact Us",
      features: [
        { name: "General and Sector Topics", icon: <CheckCircleOutlined /> },
        { name: "Full Suggestion Report", icon: <FileTextOutlined /> },
        { name: "Guidance for Gaps", icon: <BulbOutlined /> },
        { name: "Progress Dashboard", icon: <SafetyCertificateOutlined /> },
        { name: "Performance Reports", icon: <BarChartOutlined /> },
        // { name: "Reporting by Location", icon: <EnvironmentOutlined /> },
        { name: "Create Custom Topics", icon: <EditOutlined /> },
        { name: "AI Assistant", icon: <RobotOutlined /> }
      ],

    }
  ];

  const paypalRef = useRef();
  const pricingPlanStarted = useRef(false);
  const history = useHistory();

  const [userPlanId, setUserPlanId] = useState(null);
  const isRenewFlow = location.state?.fromRenew === true;
  const [custName, setCustName] = useState("");
  const [manage_sub_modal, setManage_sub_modal] = useState(false);
  const [payment_details, setPaymentDetails] = useState([]);
  const [customer1, setCustomer1] = useState("");
  const [speccodeInput, setSpeccodeInput] = useState("");
  const [specialPriceCriteriaModal, setSpecialPriceCriteriaModal] =
    useState(false);
  const [specialPriceCriteriaText, setSpecialPriceCriteriaText] =
    useState("");
  const [validatingSpeccode, setValidatingSpeccode] = useState(false);
  console.log(theme, "theme");
  // const cust = () =>{
  //   setCustomer(localStorage.getItem('customerid'));
  //const customer = localStorage.getItem('customerid');
  //console.log(customer, "customer");
  // }

  const handleApplySpeccode = () => {
    const code = (speccodeInput || "").trim();
    if (!code) {
      return;
    }
    setValidatingSpeccode(true);
    validate_special_price_code_api({ speccode: code })
      .then((res) => {
        const d = res.data || {};
        const status =
          d.status ||
          (d.result && d.result.status) ||
          (d.data && d.data.status);
        const crit =
          d.criteria != null
            ? d.criteria
            : d.result && d.result.criteria != null
              ? d.result.criteria
              : d.data && d.data.criteria != null
                ? d.data.criteria
                : "";

        const specprice =
          d.specprice != null ? d.specprice
          : d.result?.specprice != null ? d.result.specprice
          : d.data?.specprice != null ? d.data.specprice
          : null;

        const pymtid =
          d.pymtid != null ? d.pymtid
          : d.result?.pymtid != null ? d.result.pymtid
          : d.data?.pymtid != null ? d.data.pymtid
          : null;

        const pymtdesc =
          d.pymtdesc != null ? d.pymtdesc
          : d.result?.pymtdesc != null ? d.result.pymtdesc
          : d.data?.pymtdesc != null ? d.data.pymtdesc
          : null;

        const userlimit =
          d.userlimit != null ? d.userlimit
          : d.result?.userlimit != null ? d.result.userlimit
          : d.data?.userlimit != null ? d.data.userlimit
          : null;

        if (status === "invalid") {
          message.error("You entered an invalid special price code.");
        } else if (status === "inactive") {
          message.error("This special pricing code is no longer active.");
        } else if (status === "valid") {
          setConfirmedSpeccodeData({
            specprice,
            speccode: code,
            pymtid,
            pymtdesc,
            userlimit,
            criteria: crit,
          });
          setSpecialPriceCriteriaText(
            crit != null && crit !== "" ? String(crit) : ""
          );
          setSpecialPriceCriteriaModal(true);
        } else {
          message.error(
            d.message || "Unable to validate the special price code."
          );
        }
      })
      .catch((err) => {
        message.error(
          (err && err.message) || "Unable to validate the special price code."
        );
      })
      .finally(() => setValidatingSpeccode(false));
  };

  const proceedSpecialPriceCriteria = () => {
    setSpecialPriceCriteriaModal(false);

    if (!confirmedSpeccodeData) return;

    const { specprice, speccode, pymtid, pymtdesc, userlimit } =
      confirmedSpeccodeData;

    const formatSpecialUserLimit = (limit) => {
      if (limit == null || limit === "") return null;
      const s = String(limit).trim();
      if (/^up to /i.test(s)) return s;
      if (/^\d+$/.test(s)) return `up to ${s}`;
      return s;
    };

    // Find the matching plan by pymtid or fallback to Small Business (id:2)
    const matchedPlan = plans.find(
      (p) => p.price_id === pymtid || String(p.id) === String(pymtid)
    ) || plans.find((p) => p.id === 2);

    if (!matchedPlan) {
      message.error("No matching plan found for this special price code.");
      return;
    }

    const specialUsersDisplay = formatSpecialUserLimit(userlimit);

    // Override plan price with special price; use API pymtdesc/userlimit for display
    const specialPlan = {
      ...matchedPlan,
      name:
        pymtdesc != null && pymtdesc !== ""
          ? String(pymtdesc)
          : matchedPlan.name,
      users: specialUsersDisplay ?? matchedPlan.users,
      pymtdesc:
        pymtdesc != null && pymtdesc !== "" ? String(pymtdesc) : null,
      userlimit: specialUsersDisplay,
      price: specprice ?? matchedPlan.price,
      speccode: speccode,
      specprice: specprice,
      pymtid: pymtid,
      isSpecialPrice: true,
    };

    localStorage.setItem("enroll_speccode", speccode || "");
    localStorage.setItem(
      "enroll_specprice",
      specprice != null && specprice !== "" ? String(specprice) : ""
    );
    localStorage.setItem(
      "enroll_pymtid",
      pymtid != null && pymtid !== "" ? String(pymtid) : ""
    );

    userSessionDataEnroll(specialPlan);
  };

  const cancelSpecialPriceCriteria = () => {
    setSpecialPriceCriteriaModal(false);
    setSpeccodeInput("");
    setSpecialPriceCriteriaText("");
    setConfirmedSpeccodeData(null);
    localStorage.removeItem("enroll_speccode");
    localStorage.removeItem("enroll_specprice");
    localStorage.removeItem("enroll_pymtid");
    localStorage.removeItem("enroll_pymtdesc");
    localStorage.removeItem("enroll_userlimit");
  };




  const userSessionDataEnroll = (plan) => {
    if (plan.isSpecialPrice) {
      localStorage.setItem("enroll_speccode", plan.speccode || "");
      localStorage.setItem(
        "enroll_specprice",
        plan.specprice != null && plan.specprice !== ""
          ? String(plan.specprice)
          : ""
      );
      localStorage.setItem(
        "enroll_pymtid",
        plan.pymtid != null && plan.pymtid !== "" ? String(plan.pymtid) : ""
      );
      localStorage.setItem("enroll_pymtdesc", plan.pymtdesc || plan.name || "");
      localStorage.setItem(
        "enroll_userlimit",
        plan.userlimit != null && plan.userlimit !== ""
          ? String(plan.userlimit)
          : plan.users || ""
      );
      localStorage.setItem("Enroll_PlanID", plan.pymtid);
      console.log("Enroll_PlanIDD", plan.pymtid);
    } else {
      localStorage.removeItem("enroll_speccode");
      localStorage.removeItem("enroll_specprice");
      localStorage.removeItem("enroll_pymtid");
      localStorage.removeItem("enroll_pymtdesc");
      localStorage.removeItem("enroll_userlimit");
      localStorage.setItem("Enroll_PlanID", plan.id);
      console.log("Enroll_PlanIDDD", plan.pymtid);
    }

    

    console.log("Selected plan stored:", plan.id);
    localStorage.setItem(
      "Renew_Plan",
      "no"
    );

    console.log("price", localStorage.getItem("ManageSub"));
    localStorage.getItem("ManageSub") == 1002
      ? cancel_subscription_api({
        userid: localStorage.getItem("UserID"),
      })
        .then((res) => {
          console.log(res);
          if (
            res.data.message == "user dont have any subscription" ||
            "subscription has already cancelled"
          ) {
            user_session_data_enroll_api({
              userid: localStorage.getItem("UserID"),
              // userid: 100000007,
              selpymtid:
                localStorage.getItem("Enroll_PlanID") ||
                localStorage.getItem("Client_PlanID"),
            })
              .then((res2) => {
                if (res2.data.code == 200) {
                  console.log("user session data==>", res2.data);
                  localStorage.setItem("EnrData", JSON.stringify(res2.data));
                  localStorage.setItem("Enr", res2.data.Enrolling);
                  if (res2.data.Enrolling == "Free") {
                    console.log("Free Enrolling");

                    user_session_data_configfree_api({
                      userid:
                        localStorage.getItem("E_Userid") ||
                        localStorage.getItem("UserID"),
                    })
                      .then((res3) => {
                        if (res3.data.code == 200) {
                          console.log("vasanth 1 ==>");
                          setCustName(res3.data.updated_customer[0].custdesc);
                          console.log("user session data==>", res3.data);

                          free_add_custadmin_api({
                            userid:
                              localStorage.getItem("E_Userid") ||
                              localStorage.getItem("UserID"),
                          })
                            .then((res) => {
                              console.log(res);
                              if (res.data.code === 200) {
                                history.push("/login");
                              }
                            })
                            .catch((err) => {
                              console.log(err);
                            });
                        }
                      })
                      .catch((err3) => {
                        console.log("error enroll===>", err3);
                      });
                  }

                  if (res2.data.Enrolling == "Paid") {
                    console.log("Paid Enrolling 3");
                    //history.push("/payment");
                    const safePlan = {
                      id: plan.id,
                      name: plan.name,
                      location: plan.location,
                      users: plan.users,
                      price: plan.price,
                      price_id: plan.price_id,
                      speccode: plan.speccode || null,
                      pymtid: plan.pymtid || null,
                      specprice: plan.specprice || null,
                      isSpecialPrice: plan.isSpecialPrice || false,
                      pymtdesc: plan.pymtdesc || null,
                      userlimit: plan.userlimit || null,
                    };

                    history.push({
                      pathname: "/payment",
                      state: { plan: safePlan,
                      payment_details: payment_details,
                      speccode: plan.speccode || null,
                      specprice: plan.specprice || null,
                      pymtid: plan.pymtid || null,
                     },
                    });

                  }
                }

                if (res2.data.notice == "triallimit") {
                  setCustName(
                    res2.data.Custdesc[0].Custdesc || res2.data.Custdesc
                  );
                  message.info(
                    `${custName} has already used a Trial plan. Please select another plan.`,
                    6
                  );
                } else if (res2.data.message == "noenrollyet") {
                  setCustName(
                    res2.data.Custdesc[0].Custdesc || res2.data.Custdesc
                  );
                  message.info(
                    `Get with contractor ${custName} to determine your enrollment status.`,
                    6
                  );
                } else if (res2.data.message == "clientplan") {
                  message.info(
                    `You are registered as client to a contractor. Get with your contractor if you want to make a change to your enrollment status.`,
                    10
                  );
                  history.push("/login");
                } else if (res2.data.notice == "secondcust") {
                  setCustName(
                    res2.data.Custdesc[0].Custdesc || res2.data.Custdesc
                  );
                  message.info(
                    `You are already an active member of customer ${custName}. Either have them delete you from their list or try enrolling with another email.`,
                    11
                  );
                  history.push("/login");
                } else if (res2.data.notice == "enrolluser") {
                  // message.info(
                  //   `You will now be directed automatically to our secured enrollment site.`,
                  //   2
                  // );
                  // history.push("/payment");
                  const safePlan = {
                    id: plan.id,
                    name: plan.name,
                    location: plan.location,
                    users: plan.users,
                    price: plan.price,
                    price_id: plan.price_id,
                    speccode: plan.speccode || null,
                    specprice: plan.specprice || null,
                    pymtid: plan.pymtid || null,
                    isSpecialPrice: plan.isSpecialPrice || false,
                    pymtdesc: plan.pymtdesc || null,
                    userlimit: plan.userlimit || null,
                  };

                  history.push({
                    pathname: "/payment",
                    state: {
                      plan: safePlan,
                      payment_details: payment_details,
                      speccode: plan.speccode || null,
                      specprice: plan.specprice || null,
                      pymtid: plan.pymtid || null,
                    },
                  });

                } else if (res2.data.message == "custsetup") {
                  user_session_data_custsetup_ep_api({
                    sp_userid: null,
                    ep_userid: localStorage.getItem("UserID"),
                  })
                    .then((res3) => {
                      if (res3.data.code == 200) {
                        console.log(res3);

                        let data3 = {
                          userid: localStorage.getItem("UserID"),
                        };

                        custfeature_api(data3)
                          .then((res4) => {
                            console.log(res4);
                            if (res4.data.code === 200) {
                              console.log(
                                "cust feature res4 data==>",
                                res4.data
                              );
                              // message.success("Successfully3 !");

                              user_session_data_access_api(
                                localStorage.getItem("UserID")
                              )
                                .then((res5) => {
                                  console.log(res5);
                                  if (res5.data.code === 200) {
                                    console.log(
                                      "user session res5 data==>",
                                      res5.data
                                    );
                                    history.push("/login");
                                  } else {
                                    // message.error(res4.data.message);
                                    console.log(res5.data.message);
                                  }
                                })
                                .catch((err5) => {
                                  console.log("error usd--->>", err5);
                                });
                            } else {
                              // message.error(res3.data.message);
                              console.log(res4.data.message);
                            }
                          })
                          .catch((err4) => {
                            console.log("error cf--->>", err4);
                          });
                      } else {
                        message.error("Something went wrong");
                      }
                    })
                    .catch((err3) => {
                      console.log(err3);
                    });
                } else if (res2.data.message == "custstatus") {
                  after_successful_login_api({
                    userid: localStorage.getItem("UserID"),
                  })
                    .then((res3) => {
                      if (res3.data.code == 200) {
                        console.log(res3);

                        let data3 = {
                          userid: localStorage.getItem("UserID"),
                        };

                        custfeature_api(data3)
                          .then((res4) => {
                            console.log(res4);
                            if (res4.data.code === 200) {
                              console.log(
                                "cust feature res4 data==>",
                                res4.data
                              );
                              // message.success("Successfully3 !");

                              user_session_data_access_api(
                                localStorage.getItem("UserID")
                              )
                                .then((res5) => {
                                  console.log(res5);
                                  if (res5.data.code === 200) {
                                    console.log(
                                      "user session res5 data==>",
                                      res5.data
                                    );
                                    history.push("/login");
                                  } else {
                                    // message.error(res4.data.message);
                                    console.log(res5.data.message);
                                  }
                                })
                                .catch((err5) => {
                                  console.log("error usd--->>", err5);
                                });
                            } else {
                              // message.error(res3.data.message);
                              console.log(res4.data.message);
                            }
                          })
                          .catch((err4) => {
                            console.log("error cf--->>", err4);
                          });
                      } else {
                        message.error("Something went wrong");
                      }
                    })
                    .catch((err3) => {
                      console.log(err3);
                    });
                } else if (res2.data.notice == "continueon") {
                  setManage_sub_modal(true);
                }
              })
              .catch((err2) => {
                console.log("error enroll===>", err2);
              });
          } else {
            subscription_api({
              userid: localStorage.getItem("UserID"),
              subscription: res.data.subscription,
              customer: JSON.parse(localStorage.getItem("CustData")),
              plan_id: localStorage.getItem("Enroll_PlanID"),
            })
              .then((res1) => {
                if (res1.data.code == 200) {
                  console.log(res1);

                  user_session_data_enroll_api({
                    userid: localStorage.getItem("UserID"),
                    // userid: 100000007,
                    selpymtid:
                      localStorage.getItem("Enroll_PlanID") ||
                      localStorage.getItem("Client_PlanID"),
                  })
                    .then((res2) => {
                      if (res2.data.code == 200) {
                        //   message.success("Successful");
                        console.log("user session data==>", res2.data);
                        localStorage.setItem(
                          "EnrData",
                          JSON.stringify(res.data)
                        );
                        localStorage.setItem("Enr", res2.data.Enrolling);
                        if (res2.data.Enrolling == "Free") {
                          console.log("Free Enrolling");

                          user_session_data_configfree_api({
                            userid:
                              localStorage.getItem("E_Userid") ||
                              localStorage.getItem("UserID"),
                          })
                            .then((res3) => {
                              if (res3.data.code == 200) {
                                console.log("vasanth 2 ==>");
                                // setCustName(res3.data.updated_customer[0].custdesc);
                                // console.log("user session data==>", res3.data);

                                // free_add_custadmin_api({
                                //   userid:
                                //     localStorage.getItem("E_Userid") ||
                                //     localStorage.getItem("UserID"),
                                // })
                                //   .then((res) => {
                                //     console.log(res);
                                //     if (res.data.code === 200) {
                                //       history.push("/login");
                                //     }
                                //   })
                                //   .catch((err) => {
                                //     console.log(err);
                                //   });
                              }
                            })
                            .catch((err3) => {
                              console.log("error enroll===>", err3);
                            });
                        }

                        if (res2.data.Enrolling == "Paid") {
                          console.log("Paid Enrolling 1");
                          //history.push("/payment"); 
                          const safePlan = {
                            id: plan.id,
                            name: plan.name,
                            location: plan.location,
                            users: plan.users,
                            price: plan.price,
                            price_id: plan.price_id,
                            speccode: plan.speccode || null,
                            pymtid: plan.pymtid || null,
                            specprice: plan.specprice || null,
                            isSpecialPrice: plan.isSpecialPrice || false,
                            pymtdesc: plan.pymtdesc || null,
                            userlimit: plan.userlimit || null,
                          };

                          history.push({
                            pathname: "/payment",
                            state: { plan: safePlan, 
                            payment_details: payment_details,
                            speccode: plan.speccode || null,
                            specprice: plan.specprice || null,
                            pymtid: plan.pymtid || null,
                          },
                          });

                        }
                      }

                      if (res2.data.notice == "triallimit") {
                        setCustName(
                          res2.data.Custdesc[0].Custdesc || res2.data.Custdesc
                        );
                        message.info(
                          `${custName} has already used a Trial plan. Please select another plan.`,
                          6
                        );
                      } else if (res2.data.message == "noenrollyet") {
                        setCustName(
                          res2.data.Custdesc[0].Custdesc || res2.data.Custdesc
                        );
                        message.info(
                          `Get with contractor ${custName} to determine your enrollment status.`,
                          6
                        );
                      } else if (res2.data.message == "clientplan") {
                        message.info(
                          `You are registered as client to a contractor. Get with your contractor if you want to make a change to your enrollment status.`,
                          10
                        );
                        history.push("/login");
                      } else if (res2.data.notice == "secondcust") {
                        setCustName(
                          res2.data.Custdesc[0].Custdesc || res2.data.Custdesc
                        );
                        message.info(
                          `You are already an active member of customer ${custName}. Either have them delete you from their list or try enrolling with another email.`,
                          11
                        );
                        history.push("/login");
                      } else if (res2.data.notice == "enrolluser") {
                        // message.info(
                        //   `You will now be directed automatically to our secured enrollment site.`,
                        //   2
                        // );
                        // history.push("/payment");
                        const safePlan = {
                          id: plan.id,
                          name: plan.name,
                          location: plan.location,
                          users: plan.users,
                          price: plan.price,
                          price_id: plan.price_id,
                          speccode: plan.speccode || null,
                          specprice: plan.specprice || null,
                          pymtid: plan.pymtid || null,
                          isSpecialPrice: plan.isSpecialPrice || false,
                          pymtdesc: plan.pymtdesc || null,
                          userlimit: plan.userlimit || null,
                        };

                        history.push({
                          pathname: "/payment",
                          state: {
                            plan: safePlan,
                            payment_details: payment_details,
                            speccode: plan.speccode || null,
                            specprice: plan.specprice || null,
                            pymtid: plan.pymtid || null,
                          },
                        });

                      } else if (res2.data.message == "custsetup") {
                        user_session_data_custsetup_ep_api({
                          sp_userid: null,
                          ep_userid: localStorage.getItem("UserID"),
                        })
                          .then((res3) => {
                            if (res3.data.code == 200) {
                              console.log(res3);

                              let data3 = {
                                userid: localStorage.getItem("UserID"),
                              };

                              custfeature_api(data3)
                                .then((res4) => {
                                  console.log(res4);
                                  if (res4.data.code === 200) {
                                    console.log(
                                      "cust feature res4 data==>",
                                      res4.data
                                    );
                                    // message.success("Successfully3 !");

                                    user_session_data_access_api(
                                      localStorage.getItem("UserID")
                                    )
                                      .then((res5) => {
                                        console.log(res5);
                                        if (res5.data.code === 200) {
                                          console.log(
                                            "user session res5 data==>",
                                            res5.data
                                          );
                                          history.push("/login");
                                        } else {
                                          // message.error(res4.data.message);
                                          console.log(res5.data.message);
                                        }
                                      })
                                      .catch((err5) => {
                                        console.log("error usd--->>", err5);
                                      });
                                  } else {
                                    // message.error(res3.data.message);
                                    console.log(res4.data.message);
                                  }
                                })
                                .catch((err4) => {
                                  console.log("error cf--->>", err4);
                                });
                            } else {
                              message.error("Something went wrong");
                            }
                          })
                          .catch((err3) => {
                            console.log(err3);
                          });
                      } else if (res2.data.message == "custstatus") {
                        after_successful_login_api({
                          userid: localStorage.getItem("UserID"),
                        })
                          .then((res3) => {
                            if (res3.data.code == 200) {
                              console.log(res3);

                              let data3 = {
                                userid: localStorage.getItem("UserID"),
                              };

                              custfeature_api(data3)
                                .then((res4) => {
                                  console.log(res4);
                                  if (res4.data.code === 200) {
                                    console.log(
                                      "cust feature res4 data==>",
                                      res4.data
                                    );
                                    // message.success("Successfully3 !");

                                    user_session_data_access_api(
                                      localStorage.getItem("UserID")
                                    )
                                      .then((res5) => {
                                        console.log(res5);
                                        if (res5.data.code === 200) {
                                          console.log(
                                            "user session res5 data==>",
                                            res5.data
                                          );
                                          history.push("/login");
                                        } else {
                                          // message.error(res4.data.message);
                                          console.log(res5.data.message);
                                        }
                                      })
                                      .catch((err5) => {
                                        console.log("error usd--->>", err5);
                                      });
                                  } else {
                                    // message.error(res3.data.message);
                                    console.log(res4.data.message);
                                  }
                                })
                                .catch((err4) => {
                                  console.log("error cf--->>", err4);
                                });
                            } else {
                              message.error("Something went wrong");
                            }
                          })
                          .catch((err3) => {
                            console.log(err3);
                          });
                      } else if (res2.data.notice == "continueon") {
                        setManage_sub_modal(true);
                      }
                    })
                    .catch((err2) => {
                      console.log("error enroll===>", err2);
                    });
                }
              })
              .catch((err1) => {
                console.log(err1);
              });
          }
          // }
          // else {
          //   message.error("Something went wrong");
          // }
        })
        .catch((err) => {
          console.log(err);
        })
      : user_session_data_enroll_api({
        userid:
          localStorage.getItem("E_Userid") || localStorage.getItem("UserID"),
        // userid: 100000007,
        selpymtid:
          localStorage.getItem("Enroll_PlanID") ||
          localStorage.getItem("Client_PlanID"),
      })
        .then((res) => {
          console.log("user session data 24==>", res.data);
          if (res.data.code == 200) {
            message.success("Successful");
            console.log("user session data 24==>", res.data);
            localStorage.setItem("EnrData", JSON.stringify(res.data));
            localStorage.setItem("Enr", res.data.Enrolling);
            if (res.data.Enrolling == "Free") {
              console.log("Free Enrolling ==>", res);

              user_session_data_configfree_api({
                userid:
                  localStorage.getItem("E_Userid") ||
                  localStorage.getItem("UserID"),
              })
                .then((res3) => {
                  if (res3.data.code == 200) {
                    console.log("vasanth 3 ==>");
                    setCustName(res3.data.updated_customer[0].custdesc);
                    console.log("user session data==>", res3.data);

                    free_add_custadmin_api({
                      userid:
                        localStorage.getItem("E_Userid") ||
                        localStorage.getItem("UserID"),
                    })
                      .then((res) => {
                        console.log(res);
                        if (res.data.code === 200) {
                          history.push("/login");
                        }
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                  }
                })
                .catch((err3) => {
                  console.log("error enroll===>", err3);
                });
            }

            if (res.data.Enrolling == "Paid") {
              console.log("Paid Enrolling 2");
              // history.push("/payment");
              const safePlan = {
                id: plan.id,
                name: plan.name,
                location: plan.location,
                users: plan.users,
                price: plan.price,
                price_id: plan.price_id,
                speccode: plan.speccode || null,
                pymtid: plan.pymtid || null,
                specprice: plan.specprice || null,
                isSpecialPrice: plan.isSpecialPrice || false,
                pymtdesc: plan.pymtdesc || null,
                userlimit: plan.userlimit || null,
              };

              history.push({
                pathname: "/payment",
                state: { plan: safePlan, 
                payment_details: payment_details,
                speccode: plan.speccode || null,
                specprice: plan.specprice || null,
                pymtid: plan.pymtid || null,
              },
              });

            }
          }

          if (res.data.notice == "triallimit") {
            setCustName(res.data.Custdesc[0].Custdesc || res.data.Custdesc);
            message.info(
              `${custName} has already used a Trial plan. Please select another plan.`,
              6
            );
          } else if (res.data.message == "noenrollyet") {
            setCustName(res.data.Custdesc[0].Custdesc || res.data.Custdesc);
            message.info(
              `Get with contractor ${custName} to determine your enrollment status.`,
              6
            );
          } else if (res.data.message == "clientplan") {
            message.info(
              `You are registered as client to a contractor. Get with your contractor if you want to make a change to your enrollment status.`,
              10
            );
            history.push("/login");
          } else if (res.data.notice == "secondcust") {
            setCustName(res.data.Custdesc[0].Custdesc || res.data.Custdesc);
            message.info(
              `You are already an active member of customer ${custName}. Either have them delete you from their list or try enrolling with another email.`,
              11
            );
            history.push("/login");
          } else if (res.data.notice == "enrolluser") {
            // message.info(
            //   `You will now be directed automatically to our secured enrollment site.`,
            //   2
            // );
            //   history.push("/payment");
            const safePlan = {
              id: plan.id,
              name: plan.name,
              location: plan.location,
              users: plan.users,
              price: plan.price,
              price_id: plan.price_id,
              speccode: plan.speccode || null,
              specprice: plan.specprice || null,
              pymtid: plan.pymtid || null,
              isSpecialPrice: plan.isSpecialPrice || false,
              pymtdesc: plan.pymtdesc || null,
              userlimit: plan.userlimit || null,
            };

            history.push({
              pathname: "/payment",
              state: {
                plan: safePlan,
                payment_details: payment_details,
                speccode: plan.speccode || null,
                specprice: plan.specprice || null,
                pymtid: plan.pymtid || null,
              },
            });

          } else if (res.data.message == "custstatus") {
            after_successful_login_api({
              userid: localStorage.getItem("UserID"),
            })
              .then((res3) => {
                if (res3.data.code == 200) {
                  console.log(res3);

                  let data3 = {
                    userid: localStorage.getItem("UserID"),
                  };

                  custfeature_api(data3)
                    .then((res4) => {
                      console.log(res4);
                      if (res4.data.code === 200) {
                        console.log("cust feature res4 data==>", res4.data);
                        // message.success("Successfully3 !");

                        user_session_data_access_api(
                          localStorage.getItem("UserID")
                        )
                          .then((res5) => {
                            console.log(res5);
                            if (res5.data.code === 200) {
                              console.log(
                                "user session res5 data==>",
                                res5.data
                              );
                              history.push("/login");
                            } else {
                              // message.error(res4.data.message);
                              console.log(res5.data.message);
                            }
                          })
                          .catch((err5) => {
                            console.log("error usd--->>", err5);
                          });
                      } else {
                        // message.error(res3.data.message);
                        console.log(res4.data.message);
                      }
                    })
                    .catch((err4) => {
                      console.log("error cf--->>", err4);
                    });
                } else {
                  message.error("Something went wrong");
                }
              })
              .catch((err3) => {
                console.log(err3);
              });
          } else if (res.data.message == "custsetup") {
            user_session_data_custsetup_ep_api({
              sp_userid: null,
              ep_userid:
                localStorage.getItem("E_Userid") ||
                localStorage.getItem("UserID"),
            })
              .then((res2) => {
                if (res2.data.code == 200) {
                  console.log(res2);

                  let data3 = {
                    userid:
                      localStorage.getItem("E_Userid") ||
                      localStorage.getItem("UserID"),
                  };

                  custfeature_api(data3)
                    .then((res3) => {
                      console.log(res3);
                      if (res3.data.code === 200) {
                        console.log("cust feature res3 data==>", res3.data);
                        // message.success("Successfully3 !");

                        user_session_data_access_api(
                          localStorage.getItem("E_Userid")
                        )
                          .then((res4) => {
                            console.log(res4);
                            if (res4.data.code === 200) {
                              console.log(
                                "user session res4 data==>",
                                res4.data
                              );
                              history.push("/login");
                            } else {
                              // message.error(res4.data.message);
                              console.log(res4.data.message);
                            }
                          })
                          .catch((err) => {
                            console.log("error usd--->>", err);
                          });
                      } else {
                        // message.error(res3.data.message);
                        console.log(res3.data.message);
                      }
                    })
                    .catch((err) => {
                      console.log("error cf--->>", err);
                    });
                } else {
                  message.error("Something went wrong");
                }
              })
              .catch((err3) => {
                console.log(err3);
              });
          } else if (res.data.notice == "continueon") {
            setManage_sub_modal(true);
          }
        })
        .catch((err) => {
          console.log("error enroll===>", err);
        });


  };

  useEffect(() => {

    user_payment_details_api({
      userid: localStorage.getItem("UserID")
    })
      .then((res2) => {
        if (res2.data.code === 200 && res2.data.payment_details[0]) {
          const plan_id = res2.data.payment_details[0].plan_id;
          console.log("plan_id", plan_id);
          setPaymentDetails(res2.data.payment_details[0]);
          console.log("yesssss111");
          if(localStorage.getItem("renewFlag")=="yes"){
  console.log("yesssss");
}
else{
  console.log("setUserPlanId",plan_id);
 setUserPlanId(plan_id);
}
         
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
      });

    // Load PayPal script dynamically
    const script = document.createElement("script");
    script.src =
      "https://www.paypal.com/sdk/js?client-id=AYtLwWNCSOe_jr8mNSvsDzt--dg1fiQHMa3fraHtvcDGbO2rdxRCNF14P1yWLYMbvxSjGkbdoKKor3A2&vault=true&intent=subscription&disable-funding=card";
    script.async = true;
    script.onload = () => {
      window.paypal
        .Buttons({
          style: {
            shape: "rect",
            color: "gold",
            layout: "vertical",
            label: "subscribe",
          },
          createSubscription: (data, actions) => {
            return actions.subscription.create({
              plan_id: "P-0CB39968PU819283VNEKCUQQ", // your PayPal plan ID
            });
          },
          onApprove: (data, actions) => {
            alert(`Subscription successful! ID: ${data.subscriptionID}`);
            // Optionally send data.subscriptionID to your backend for record
          },
          onError: (err) => {
            console.error("PayPal Error: ", err);
          },
        })
        .render(paypalRef.current);
    };
    document.body.appendChild(script);
  }, []);

  useEffect(() => {
    if (pricingPlanStarted.current || isRenewFlow) {
      return;
    }
    const pricingPlanId =
      location.state?.pricingPlanId || sessionStorage.getItem("pricing_plan");
    if (pricingPlanId !== "2" && pricingPlanId !== "3") {
      return;
    }
    const selectedPlan = plans.find((item) => String(item.id) === String(pricingPlanId));
    if (!selectedPlan) {
      return;
    }
    pricingPlanStarted.current = true;
    sessionStorage.removeItem("pricing_plan");
    userSessionDataEnroll(selectedPlan);
  }, []);

  return (
    <>
      {/* <div>
      <h3>Subscribe to Limited Trial</h3>
       <div ref={paypalRef} style={ModalStyle_Del}></div>
    </div> */}



      <div className="container pb-5">

        <div className="mt-4 px-4">

          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">

            {/* Return Button */}
            <div className="mb-3 mb-md-0">
              <StyledButton1
                onClick={() => {
                  localStorage.getItem("PlanID") != 1 &&
                  localStorage.getItem("token") != null
                    ? history.push("/adminfunctionmodal")
                    : localStorage.getItem("PlanID") == 1 &&
                      localStorage.getItem("token") != null
                    ? history.push("/dashboard")
                    : window.open("https://guvrix.com/pricing/", "_blank");
                }}
              >
                Return to Main Menu
              </StyledButton1>
            </div>

            {/* Special Price Code */}
            <div className="d-flex flex-column flex-sm-row align-items-center">

              <label className="me-sm-2 mb-2 mb-sm-0 fw-bold">
                Special Price Code
              </label>

              <input
                type="text"
                className="form-control me-sm-2 mb-2 mb-sm-0"
                style={{
                  width: window.innerWidth < 576 ? "100%" : "180px"
                }}
                value={speccodeInput}
                onChange={(e) => setSpeccodeInput(e.target.value)}
                disabled={validatingSpeccode}
              />

              <StyledApplyButton
                type="button"
                disabled={validatingSpeccode}
                onClick={handleApplySpeccode}
              >
                Apply
              </StyledApplyButton>

            </div>

          </div>

        </div>

        <div className="row pt-2 justify-content-center">

          <div className="container py-5">
            <div className="row justify-content-center">
              {plans.map((plan, index) => (
                <div key={index} className="col-lg-3 col-md-6 mb-4">
                  <div className={`card h-100 shadow-sm border-0`}>
                    <div className="card-header pt-3 pb-3 text-center" style={{
                      background: `${theme}`,
                      color: "white",
                      fontSize: 20,
                      fontWeight: "bold",
                      borderRadius: "20px 20px 0px 0px",
                    }}>

                      {plan.name}

                    </div>
                    <div className="card-body d-flex flex-column">
                      {/* Plan Details */}
                      <div>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className="text-muted">Entities*</span>
                          <span className="fw-semibold">{plan.location}</span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <span className="text-muted">Users</span>
                          <span className="fw-semibold">{plan.users}</span>
                        </div>
                        <div className="text-center my-4">
                          {plan.id === 5 ? (
                            <h3>Contact Admin</h3>
                          ) : (
                            <h3>${plan.price} per year</h3>
                          )}
                        </div>

                      </div>

                      {/* Button */}


                      {/* Features */}
                      <div>
                        <h6 className="text-muted mb-3">All Features and Functions, including:</h6>
                        <ul className="list-unstyled">
                          {plan.features.map((feature, featureIndex) => (
                            <li key={featureIndex} className="mb-2 d-flex align-items-center">
                              <span className="me-2" style={{ fontSize: '16px', color: `${theme}` }}>
                                {feature.icon}
                              </span>
                              <small className="text-dark">{feature.name}</small>
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className="text-center mb-4 mt-auto">

                        {/* Show Current Plan label if disabled */}
                        {/* {(userPlanId == "2" && plan.price == 660) ||
                          (userPlanId == "3" && plan.price == 1800) ? (
                          <p style={{ fontWeight: "bold", fontSize: "18px", marginBottom: "8px" }}>
                            Current Plan
                          </p>
                        ) : null} */}
                        {!isRenewFlow &&
                          ((userPlanId == "2" && plan.price == 660) ||
                            (userPlanId == "3" && plan.price == 1800)) ? (
                          <p style={{ fontWeight: "bold", fontSize: "18px", marginBottom: "8px" }}>
                            Current Plan
                          </p>
                        ) : null}


                        <StyledButton1

                          disabled={
                            (renewFlag && plan.buttonText === "Go to Dashboard") ||
                            !isRenewFlow &&
                            (
                              (userPlanId == "2" && plan.price == 660) ||
                              (userPlanId == "3" && plan.price == 1800) ||
                              (plan.id == "1" && (userPlanId == "2" || userPlanId == "3"))
                            )
                          }
                          onClick={() => {
                            if (
                              !isRenewFlow &&
                              (
                                (userPlanId == "2" && plan.price == 660) ||
                                (userPlanId == "3" && plan.price == 1800) ||
                                (plan.id == "1" && (userPlanId == "2" || userPlanId == "3"))
                              )
                            ) return;

                            if (plan.buttonText == "Go to Dashboard") {
                              localStorage.setItem("PlanID", 1);
                              localStorage.setItem("Enroll_PlanID", 1);
                              history.push("/dashboard");
                            } else if (plan.buttonText == "Contact Us") {
                              window.open("https://guvrix.com/contact/", "_blank");
                            } else {
                              userSessionDataEnroll(plan);
                            }
                          }}
                        >
                          {plan.buttonText}
                        </StyledButton1>

                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="row justify-content-center">
              <p style={{ fontSize: "16px" }}>*Entities include a distinct physical or logical entity that will be generating their own questionnaires, separate from another entity. Examples include a city, physical office, operations site, function, or department.</p>
            </div>

            {/* Additional Styling */}
            <style jsx>{`
        .card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        
        .card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 25px rgba(0,0,0,0.1) !important;
        }
        
        .card-header {
          border-bottom: 2px solid #f8f9fa;
        }
        
        .btn-outline-warning {
          border-width: 2px;
          font-weight: 900;
        }
        
        .btn-outline-primary {
          border-width: 2px;
          font-weight: 900;
        }
      `}</style>
          </div>
          {/* <div className="col-sm-12 col-md-6 col-lg-4 mt-5">
          <div class="card">
            <div class="bg-secondary">
              <h4 className="text-white mt-3 fw-bold text-center">Free</h4>
            </div>
            <div class="card-header" style={{ backgroundColor: "#F2F3F4" }}>
              <h2 className="text-secondary mt-2 fw-bold text-center">$0</h2>
            </div>

            <ul class="list-group list-group-flush">
              <li
                style={{ fontSize: "15px" }}
                class="list-group-item fw-bold text-center text-secondary"
              >
                Access to Most Topics
              </li>
              <li
                style={{ fontSize: "15px" }}
                class="list-group-item fw-bold text-center text-secondary"
              >
                Basic Suggestion Report
              </li>
            </ul>
            <div
              class="card-header text-center"
              style={{ backgroundColor: "#F2F3F4" }}
            >
              <StyledButton1
                onClick={() => {
                  localStorage.setItem("Enroll_PlanID", 1);
                  localStorage.setItem(
                    "price_EP",
                    "price_1KX0ChCxPlnlMJHk4HwSlES6"
                  );
                  setTimeout(() => {
                    userSessionDataEnroll();
                  }, 1000);
                }}
              >
                Buy Now
              </StyledButton1>
            </div>
          </div>
        </div>

        <div className="col-sm-12 col-md-6 col-lg-4 mt-5">
          <div class="card">
            <div class="bg-secondary">
              <h4 className="text-white mt-3 fw-bold text-center">
                Enterprise
              </h4>
            </div>
            <div class="card-header" style={{ backgroundColor: "#F2F3F4" }}>
              <h3 className="text-secondary mt-2 fw-bold text-center">
                Contact Support For Details
              </h3>
            </div>

            <ul class="list-group list-group-flush">
              <li
                style={{ fontSize: "15px" }}
                class="list-group-item fw-bold text-center text-secondary"
              >
                Full Suggestion Report
              </li>
              <li
                style={{ fontSize: "15px" }}
                class="list-group-item fw-bold text-center text-secondary"
              >
                Suggestion Guidance
              </li>
              <li
                style={{ fontSize: "15px" }}
                class="list-group-item fw-bold text-center text-secondary"
              >
                Performance Reports
              </li>
      
              <li
                style={{ fontSize: "15px" }}
                class="list-group-item fw-bold text-center text-secondary"
              >
                Reporting by Location
              </li>
              <li
                style={{ fontSize: "15px" }}
                class="list-group-item fw-bold text-center text-secondary"
              >
                Create Custom Topics
              </li>
              <li
                style={{ fontSize: "15px" }}
                class="list-group-item fw-bold text-center text-secondary"
              >
                General and Sector Topics
              </li>
              <li
                style={{ fontSize: "15px" }}
                class="list-group-item fw-bold text-center text-secondary"
              >
                AI - Assistant
              </li>
            </ul>
            <div
              class="card-header text-center"
              style={{ backgroundColor: "#F2F3F4" }}
            >
              <StyledButton1
                onClick={() => {
                  localStorage.setItem("Enroll_PlanID", 5);
                  localStorage.setItem(
                    "price_EP",
                     "price_1KVxhjCxPlnlMJHk9WuL1Lew" //test price 
                  //  "price_1LMRtuCxPlnlMJHktegNRc9b" //live price
                  );
                  setTimeout(() => {
                    userSessionDataEnroll();
                  }, 1000);
                  window.open("https://guvrix.com/contact-us/", "_blank");
                }}
              >
                Request a Quote
              </StyledButton1>
            </div>
          </div>
        </div> */}
        </div>
      </div>



      {/* --------------- Special price criteria (Esuggest Confirm Delete style) ------------ */}
      <ReactModal
        className="ModalStyle1 Width90"
        isOpen={specialPriceCriteriaModal}
        onRequestClose={cancelSpecialPriceCriteria}
      >
        <div>
          <h4>Special price code</h4>
          <p>
            If you meet this criteria, please select Proceed. If not, select
            Cancel.
          </p>
          {specialPriceCriteriaText ? (
            <p
              style={{
                marginTop: "12px",
                whiteSpace: "pre-line",
                fontWeight: 600,
              }}
            >
              {specialPriceCriteriaText}
            </p>
          ) : null}

          <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
            <StyledButton
              style={{
                width: "250px",
                marginTop: 0,
              }}
              type="button"
              onClick={proceedSpecialPriceCriteria}
            >
              Proceed
            </StyledButton>
            <button
              type="button"
              onClick={cancelSpecialPriceCriteria}
              style={{
                width: "250px",
                borderRadius: "30px",
                height: "45px",
                textAlign: "center",
                color: "white",
                fontSize: "16px",
                fontWeight: 500,
                border: "none",
                marginTop: 0,
                padding: "5px 10px",
                backgroundColor: "red",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </ReactModal>

      {/* --------------- Manage Sub Button Modal ------------ */}
      <ReactModal style={ModalStyle_Del} isOpen={manage_sub_modal}>
        <div>
          <div align="center" className="mb-3">
            <h4 className="mt-5">
              Are you sure you want to Manage Subscription?
            </h4>
            <StyledButton
              style={{ width: "30%", height: 30, marginTop: 50 }}
              onClick={() => {
                history.push("/payment");
              }}
            >
              Proceed
            </StyledButton>
            <StyledButton
              style={{
                width: "30%",
                height: 30,
                backgroundColor: "red",
                marginLeft: 10,
              }}
              onClick={() => {
                setManage_sub_modal(false);
              }}
            >
              Cancel
            </StyledButton>
          </div>
        </div>
      </ReactModal>
    </>
  );
};

export default EnrollUI;
